<script setup>
import { computed } from "vue"

const props = defineProps({
  cols: {
    type: Number,
    default: 4
  },
  spacing: {
    default: 'none'
  },
})

const mobileCols = computed(() => props.cols >= 4 ? 2 : 1)
</script>

<template>
<div :class="['grid w-full', 'grid-cols-' + mobileCols, 'md:grid-cols-' + cols, 'gap-' + spacing]">
  <slot></slot>
</div>
</template>
